import CaseStudyHero from "./CaseStudyHero";

export default CaseStudyHero;
